import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { connectToIntegration } from "./schema/connect-to-integration";
import { disconnectConnection } from "./schema/disconnect-connection";
import { getAvailableIntegrations } from "./schema/get-available-integrations";
import { authorizeFaireIntegration } from "./schema/integrations/authorize-faire-integration";
import { getBigcommerceIntegration } from "./schema/integrations/bigcommerce/get-bigcommerce-integration";
import { setBigcommerceExchangeOrderStatus } from "./schema/integrations/bigcommerce/set-bigcommerce-exchange-order-status";
import { setBigcommerceRefundMethod } from "./schema/integrations/bigcommerce/set-bigcommerce-refund-method";
import { disconnectBlueCherryIntegration } from "./schema/integrations/blue-cherry/disconnect-blue-cherry-integration";
import { getBlueCherryIntegration } from "./schema/integrations/blue-cherry/get-blue-cherry-integration";
import { setBlueCherryIntegration } from "./schema/integrations/blue-cherry/set-blue-cherry-integration";
import { disconnectCloudXIntegration } from "./schema/integrations/cloudx/disconnect-cloudx-integration";
import { getCloudXIntegration } from "./schema/integrations/cloudx/get-cloudx-integration";
import { postCloudXIntegration } from "./schema/integrations/cloudx/post-cloudx-integration";
import { createCommentsoldIntegration } from "./schema/integrations/commentsold/create-commentsold-integration";
import { deleteCommentsoldIntegration } from "./schema/integrations/commentsold/delete-commentsold-integration";
import { enableOmsOnCommentsoldIntegration } from "./schema/integrations/commentsold/enable-oms-on-commentsold-integration";
import { getCommentsoldIntegration } from "./schema/integrations/commentsold/get-commentsold-integration";
import { getCommentsoldOAuthUrl } from "./schema/integrations/commentsold/get-commentsold-oauth-url";
import { updateCommentsoldIntegration } from "./schema/integrations/commentsold/update-commentsold-integration";
import { createCin7CoreIntegration } from "./schema/integrations/create-cin7-core-integration";
import { createCin7OmniIntegration } from "./schema/integrations/create-cin7-omni-integration";
import { createOmsApparelMagicIntegration } from "./schema/integrations/create-oms-apparel-magic-integration";
import { createTiktokIntegration } from "./schema/integrations/create-tiktok-integration";
import { deleteShipmonkIntegration } from "./schema/integrations/delete-shipmonk-integration";
import { disconnectFaireIntegration } from "./schema/integrations/disconnect-faire-integration";
import { disconnectOmsTiktokIntegration } from "./schema/integrations/disconnect-oms-tiktok-integration";
import { disconnectReturnsTiktokIntegration } from "./schema/integrations/disconnect-returns-tiktok-integration";
import { disconnectWalmartIntegration } from "./schema/integrations/disconnect-walmart-integration";
import { doesEbayIntegrationExist } from "./schema/integrations/does-ebay-integration-exist";
import { getDropoffTracking } from "./schema/integrations/dropoff/get-dropoff-tracking";
import { exchangeTrackstarAuthCode } from "./schema/integrations/exchange-trackstar-auth-code";
import { getAmazonAuthUrl } from "./schema/integrations/get-amazon-auth-url";
import { getAmazonIntegration } from "./schema/integrations/get-amazon-integration";
import { getCin7CoreIntegration } from "./schema/integrations/get-cin7-core-integration";
import { getCin7OmniIntegration } from "./schema/integrations/get-cin7-omni-integration";
import { getEbayAuthorizationUrl } from "./schema/integrations/get-ebay-authorization-url";
import { getEnabledFulfillmentProviders } from "./schema/integrations/get-enabled-fulfillment-providers";
import { getFaireIntegration } from "./schema/integrations/get-faire-integration";
import { getGmailRecentMessages } from "./schema/integrations/get-gmail-recent-messages";
import { getGmailThread } from "./schema/integrations/get-gmail-thread";
import { getLegacySignedOAuthState } from "./schema/integrations/get-legacy-signed-oauth-state";
import { getMarketingEcommerceProviders } from "./schema/integrations/get-marketing-ecommerce-providers";
import { getOmsApparelMagicIntegration } from "./schema/integrations/get-oms-apparel-magic-integration";
import { getOmsTiktokIntegration } from "./schema/integrations/get-oms-tiktok-integration";
import { getReturnsTiktokIntegration } from "./schema/integrations/get-returns-tiktok-integration";
import { getShipmonkIntegration } from "./schema/integrations/get-shipmonk-integration";
import { getTeamEcommerceProviders } from "./schema/integrations/get-team-ecommerce-providers";
import { getTiktokAuthorizationExpiration } from "./schema/integrations/get-tiktok-authorization-expiration";
import { getTrackstarConnections } from "./schema/integrations/get-trackstar-connections";
import { getTrackstarLinkToken } from "./schema/integrations/get-trackstar-link-token";
import { getWalmartIntegration } from "./schema/integrations/get-walmart-integration";
import { disconnectGlobalEIntegration } from "./schema/integrations/globale/disconnect-globale-integration";
import { getGlobalEIntegration } from "./schema/integrations/globale/get-globale-integration";
import { setGlobalEIntegration } from "./schema/integrations/globale/set-globale-integration";
import { disconnectIDFShippingIntegration } from "./schema/integrations/idf-shipping/disconnect-idf-shipping-integration";
import { getIDFShippingIntegration } from "./schema/integrations/idf-shipping/get-idf-shipping-integration";
import { setIDFShippingIntegration } from "./schema/integrations/idf-shipping/set-idf-shipping-integration";
import { disconnectKatanaIntegration } from "./schema/integrations/katana/disconnect-katana-integration";
import { getKatanaIntegration } from "./schema/integrations/katana/get-katana-integration";
import { setKatanaIntegration } from "./schema/integrations/katana/set-katana-integration";
import { createLandmarkGlobalIntegration } from "./schema/integrations/landmark-global/create-landmark-global-integration";
import { getLandmarkGlobalIntegration } from "./schema/integrations/landmark-global/get-landmark-global-integration";
import { disconnectLuminousIntegration } from "./schema/integrations/luminous/disconnect-luminous-integration";
import { getLuminousIntegration } from "./schema/integrations/luminous/get-luminous-integration";
import { setLuminousIntegration } from "./schema/integrations/luminous/set-luminous-integration";
import { updateLuminousIntegration } from "./schema/integrations/luminous/update-luminous-integration";
import { deleteNetSuiteIntegration } from "./schema/integrations/netsuite/delete-netsuite-integration";
import { getNetSuiteIntegration } from "./schema/integrations/netsuite/get-netsuite-integration";
import { getNetSuiteOAuthUrl } from "./schema/integrations/netsuite/get-netsuite-oauth-url";
import { retryItemReceiptEvent } from "./schema/integrations/netsuite/retry-item-receipt-event";
import { testNetSuiteReturnAuthorization } from "./schema/integrations/netsuite/test-netsuite-return-authorization";
import { upsertNetSuiteIntegration } from "./schema/integrations/netsuite/upsert-netsuite-integration";
import { updateBrightpearlOmsSettings } from "./schema/integrations/oms-brightpearl/update-brightpearl-oms-settings";
import { createOmsNetsuiteIntegration } from "./schema/integrations/oms-netsuite/create-oms-netsuite-integration";
import { getOmsNetsuiteIntegration } from "./schema/integrations/oms-netsuite/get-oms-netsuite-integration";
import { updateOmsNetsuiteIntegration } from "./schema/integrations/oms-netsuite/update-oms-netsuite-integration";
import { createParentEasypostIntegration } from "./schema/integrations/parent-easypost/create-parent-easypost-integration";
import { deleteParentEasypostIntegration } from "./schema/integrations/parent-easypost/delete-parent-easypost-integration";
import { getParentEasypostIntegration } from "./schema/integrations/parent-easypost/get-parent-easypost-integration";
import { updateParentEasypostIntegration } from "./schema/integrations/parent-easypost/update-parent-easypost-integration";
import { putShipmonkIntegration } from "./schema/integrations/put-shipmonk-integration";
import { reconnectFaireIntegration } from "./schema/integrations/reconnect-faire-integration";
import { disconnectRefundidIntegration } from "./schema/integrations/refundid/disconnect-refundid-integration";
import { getRefundidIntegration } from "./schema/integrations/refundid/get-refundid-integration";
import { setRefundidIntegration } from "./schema/integrations/refundid/set-refundid-integration";
import { resendExternalReturnShippingProviderLabel } from "./schema/integrations/resend-external-return-shipping-provider-label";
import { getReturnBearExceptions } from "./schema/integrations/returnbear/get-return-bear-exceptions";
import { getReturnBearTrackingEvents } from "./schema/integrations/returnbear/get-returnbear-tracking-events";
import { resolveReturnBearException } from "./schema/integrations/returnbear/resolve-return-bear-exception";
import { getShopifyIntegration } from "./schema/integrations/shopify/get-shopify-integration";
import { setShopifyRefundMethod } from "./schema/integrations/shopify/set-shopify-refund-method";
import { disconnectTeamworkCommerceIntegration } from "./schema/integrations/teamwork-commerce/disconnect-teamwork-commerce-integration";
import { getTeamworkCommerceIntegration } from "./schema/integrations/teamwork-commerce/get-teamwork-commerce-integration";
import { setTeamworkCommerceIntegration } from "./schema/integrations/teamwork-commerce/set-teamwork-commerce-integration";
import { updateCin7CoreIntegration } from "./schema/integrations/update-cin7-core-integration";
import { updateCin7OmniIntegration } from "./schema/integrations/update-cin7-omni-integration";
import { updateOmsApparelMagicIntegration } from "./schema/integrations/update-oms-apparel-magic-integration";
import { updateTrackstarReturnConnectionSettings } from "./schema/integrations/update-trackstar-return-connection-settings";
import { createWayfairIntegration } from "./schema/integrations/wayfair/create-wayfair-integration";
import { disconnectWayfairIntegration } from "./schema/integrations/wayfair/disconnect-wayfair-integration";
import { getWayfairIntegration } from "./schema/integrations/wayfair/get-wayfair-integration";
import {
  disconnectAims360Integration,
  getAims360Integration,
  getAllShipViaCodes,
  setAims360Integration,
  updateAims360Integration,
} from "./schema/returns-rpc/aims360";
import {
  disconnectApparelMagicIntegration,
  getApparelMagicIntegration,
  setApparelMagicIntegration,
  updateApparelMagicIntegration,
} from "./schema/returns-rpc/apparel-magic";
import {
  disconnectAuthorizeNetIntegration,
  getAuthorizeNetIntegration,
  setAuthorizeNetIntegration,
  updateAuthorizeNetIntegration,
} from "./schema/returns-rpc/authorizenet";
import {
  disconnectBlueYonderIntegration,
  getBlueYonderIntegration,
  setBlueYonderIntegration,
} from "./schema/returns-rpc/blue-yonder";
import { disconnectCreditsYardIntegration } from "./schema/returns-rpc/creditsyard/disconnect-creditsyard-integration";
import { getCreditsYardIntegration } from "./schema/returns-rpc/creditsyard/get-creditsyard-integration";
import { setCreditsYardIntegration } from "./schema/returns-rpc/creditsyard/set-creditsyard-integration";
import { updateCreditsYardIntegration } from "./schema/returns-rpc/creditsyard/update-creditsyard-integration";
import {
  disconnectCustomReturnIntegration,
  getCustomReturnIntegration,
  setCustomReturnIntegration,
} from "./schema/returns-rpc/custom-return-integration";
import {
  disconnectFlexportIntegration,
  getFlexportIntegration,
  putFlexportIntegration,
} from "./schema/returns-rpc/flexport";
import { getAllIntegrationStatuses } from "./schema/returns-rpc/get-all-integration-statuses";
import {
  disconnectInmarIntegration,
  getInmarIntegration,
  setInmarIntegration,
} from "./schema/returns-rpc/inmar";
import {
  disconnectKlaviyoIntegration,
  getKlaviyoIntegration,
  setKlaviyoIntegration,
  updateKlaviyoIntegration,
} from "./schema/returns-rpc/klaviyo";
import {
  disconnectLoopIntegration,
  getLoopIntegration,
  setLoopIntegration,
  updateLoopIntegration,
} from "./schema/returns-rpc/loop";
import {
  disconnectPurpleDotIntegration,
  getPurpleDotIntegration,
  setPurpleDotIntegration,
  updatePurpleDotIntegration,
} from "./schema/returns-rpc/purple-dot";
import {
  disconnectReturnBearIntegration,
  getReturnBearIntegration,
  setReturnBearIntegration,
  updateReturnBearIntegration,
} from "./schema/returns-rpc/returnbear";
import {
  disconnectRiseAiIntegration,
  getRiseAiIntegration,
  initiateRiseAiOAuth,
  setRiseAiIntegration,
  updateRiseAiIntegration,
} from "./schema/returns-rpc/rise-ai";
import {
  disconnectSekoIntegration,
  getSekoIntegration,
  setSekoIntegration,
  updateSekoIntegration,
} from "./schema/returns-rpc/seko";
import {
  disconnectShipedgeIntegration,
  getShipedgeIntegration,
  putShipedgeIntegration,
} from "./schema/returns-rpc/shipedge";
import {
  disconnectShipHeroIntegration,
  getShipHeroIntegration,
  getShipHeroProductBins,
  putShipheroIntegration,
  shipHeroInventoryAdd,
  validateShipHeroLocation,
} from "./schema/returns-rpc/shiphero";

export const rpcDefinition = {
  getAvailableIntegrations,
  connectToIntegration,
  disconnectConnection,
  getAllIntegrationStatuses,
  getAims360Integration,
  getAllShipViaCodes,
  setAims360Integration,
  updateAims360Integration,
  disconnectAims360Integration,
  getApparelMagicIntegration,
  setApparelMagicIntegration,
  updateApparelMagicIntegration,
  disconnectApparelMagicIntegration,
  getAuthorizeNetIntegration,
  setAuthorizeNetIntegration,
  updateAuthorizeNetIntegration,
  disconnectAuthorizeNetIntegration,
  getBlueYonderIntegration,
  setBlueYonderIntegration,
  disconnectBlueYonderIntegration,
  getCreditsYardIntegration,
  setCreditsYardIntegration,
  updateCreditsYardIntegration,
  disconnectCreditsYardIntegration,
  getCustomReturnIntegration,
  setCustomReturnIntegration,
  disconnectCustomReturnIntegration,
  getFlexportIntegration,
  putFlexportIntegration,
  disconnectFlexportIntegration,
  getInmarIntegration,
  setInmarIntegration,
  disconnectInmarIntegration,
  getKlaviyoIntegration,
  setKlaviyoIntegration,
  updateKlaviyoIntegration,
  disconnectKlaviyoIntegration,
  getLoopIntegration,
  setLoopIntegration,
  updateLoopIntegration,
  disconnectLoopIntegration,
  getPurpleDotIntegration,
  setPurpleDotIntegration,
  updatePurpleDotIntegration,
  disconnectPurpleDotIntegration,
  getReturnBearIntegration,
  setReturnBearIntegration,
  updateReturnBearIntegration,
  disconnectReturnBearIntegration,
  getRiseAiIntegration,
  initiateRiseAiOAuth,
  setRiseAiIntegration,
  updateRiseAiIntegration,
  disconnectRiseAiIntegration,
  getSekoIntegration,
  setSekoIntegration,
  updateSekoIntegration,
  disconnectSekoIntegration,
  getShipedgeIntegration,
  putShipedgeIntegration,
  disconnectShipedgeIntegration,
  getShipHeroIntegration,
  putShipheroIntegration,
  disconnectShipHeroIntegration,
  shipHeroInventoryAdd,
  validateShipHeroLocation,
  getShipHeroProductBins,
  authorizeFaireIntegration,
  getBigcommerceIntegration,
  setBigcommerceExchangeOrderStatus,
  setBigcommerceRefundMethod,
  disconnectBlueCherryIntegration,
  getBlueCherryIntegration,
  setBlueCherryIntegration,
  disconnectCloudXIntegration,
  getCloudXIntegration,
  postCloudXIntegration,
  createCommentsoldIntegration,
  deleteCommentsoldIntegration,
  enableOmsOnCommentsoldIntegration,
  getCommentsoldIntegration,
  getCommentsoldOAuthUrl,
  updateCommentsoldIntegration,
  createCin7CoreIntegration,
  createCin7OmniIntegration,
  createOmsApparelMagicIntegration,
  createTiktokIntegration,
  deleteShipmonkIntegration,
  disconnectFaireIntegration,
  disconnectOmsTiktokIntegration,
  disconnectReturnsTiktokIntegration,
  disconnectWalmartIntegration,
  doesEbayIntegrationExist,
  getDropoffTracking,
  exchangeTrackstarAuthCode,
  getAmazonAuthUrl,
  getAmazonIntegration,
  getCin7CoreIntegration,
  getCin7OmniIntegration,
  getEbayAuthorizationUrl,
  getEnabledProviders: getEnabledFulfillmentProviders,
  getFaireIntegration,
  getGmailRecentMessages,
  getGmailThread,
  getLegacySignedOAuthState,
  getMarketingEcommerceProviders,
  getOmsApparelMagicIntegration,
  getOmsTiktokIntegration,
  getReturnsTiktokIntegration,
  getShipmonkIntegration,
  getTeamEcommerceProviders,
  getTiktokAuthorizationExpiration,
  getTrackstarConnections,
  getTrackstarLinkToken,
  getWalmartIntegration,
  disconnectGlobalEIntegration,
  getGlobalEIntegration,
  setGlobalEIntegration,
  disconnectIDFShippingIntegration,
  getIDFShippingIntegration,
  setIDFShippingIntegration,
  disconnectKatanaIntegration,
  getKatanaIntegration,
  setKatanaIntegration,
  createLandmarkGlobalIntegration,
  getLandmarkGlobalIntegration,
  disconnectLuminousIntegration,
  getLuminousIntegration,
  setLuminousIntegration,
  updateLuminousIntegration,
  deleteNetSuiteIntegration,
  getNetSuiteIntegration,
  getNetSuiteOAuthUrl,
  retryItemReceiptEvent,
  testNetSuiteReturnAuthorization,
  upsertNetSuiteIntegration,
  updateBrightpearlOmsSettings,
  createOmsNetsuiteIntegration,
  getOmsNetsuiteIntegration,
  updateOmsNetsuiteIntegration,
  createParentEasypostIntegration,
  deleteParentEasypostIntegration,
  getParentEasypostIntegration,
  updateParentEasypostIntegration,
  putShipmonkIntegration,
  disconnectRefundidIntegration,
  getRefundidIntegration,
  setRefundidIntegration,
  reconnectFaireIntegration,
  resendExternalReturnShippingProviderLabel,
  getReturnBearExceptions,
  getReturnBearTrackingEvents,
  resolveReturnBearException,
  getShopifyIntegration,
  setShopifyRefundMethod,
  disconnectTeamworkCommerceIntegration,
  getTeamworkCommerceIntegration,
  setTeamworkCommerceIntegration,
  updateCin7CoreIntegration,
  updateCin7OmniIntegration,
  updateOmsApparelMagicIntegration,
  updateTrackstarReturnConnectionSettings,
  createWayfairIntegration,
  disconnectWayfairIntegration,
  getWayfairIntegration,
};

export type RedoIntegrationsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
